import { useEffect, useMemo, useState } from 'react';
import { debounce } from '@mui/material/utils';
import DateFull from '../../../components/common/FormControl/DateFull';

const DateValueEditor = ({
  field,
  onUpdateTaskValue,
  onValidationChange,
  value
}) => {
  const [internalValue, setInternalValue] = useState();
  const [isValid, setIsValid] = useState(true);

  const dateProps = useMemo(() => ({
    maxDate: new Date(Number(new Date("10000")) - 1),
    minDate: new Date("1753"),
  }), []);

  const initialValue = useMemo(() => (
    (value?.dateTimeValue) ? new Date(value.dateTimeValue) : null
  ), [value]);

  const debounceUpdateTaskValue = useMemo(
    () =>
      debounce((fieldId, newValue) => {
        var isDirty = (newValue?.valueOf() !== initialValue?.valueOf());
        if (isDirty) onUpdateTaskValue(fieldId, newValue);
        onValidationChange?.(true);
      }, 800),
    [initialValue]
  );

  useEffect(() => {
    setInternalValue(initialValue);
  }, [initialValue]);

  const handleChange = (newValue) => {
    setInternalValue(newValue);
    if (isValidDate(newValue)) {
      debounceUpdateTaskValue(field.fieldId, newValue);
      if (!isValid) {
        setIsValid(true);
      }
    }
    else if (isValid) {
      onValidationChange?.(false);
      setIsValid(false);
    }
  };

  const handleShiftKeyDown = (e) => e.shiftKey && e.stopPropagation();
  const handleShiftKeyUp = (e) => (e.key === "Shift") && e.stopPropagation();

  const isValidDate = (date) => isValidDateObject(date) && (dateProps.minDate <= date) && (date <= dateProps.maxDate);
  const isValidDateObject = (o) => (o === null || o instanceof Date && !isNaN(o));

  return (
    <DateFull
      allowNull
      label=""
      onKeyDown={handleShiftKeyDown}
      onKeyUp={handleShiftKeyUp}
      setDate={handleChange}
      value={internalValue}
      {...dateProps}
    />
  );
};

export default DateValueEditor;
